import get from 'lodash/get';
import keys from 'lodash/keys';
import identity from 'lodash/identity';
import concat from 'lodash/concat';
import map from 'lodash/map';
import reverse from 'lodash/reverse';
import pickBy from 'lodash/pickBy';
import { translateMake, capitalizeWords } from '../../../utils/commonHelper';
import { handleLegacyAllType } from '../../../utils/classHelper';
import {
  getActiveParams,
  generateSearchPath,
} from '../../../utils/urlHelpers/engines.js';

import { syncTranslationElements } from '../../../tppServices/translations/intlManager';

export const getBreadCrumb = (params, seoParams) => {
  const { formatMessage: t, messages } = syncTranslationElements();
  let seoElements = [];

  // Pick only active parameters that are not empty
  params = pickBy(params, identity);
  let active = getActiveParams(params);

  // Make - Model order
  if (get(active, 'makeModel')) {
    map(setMultifacetedBreadCrumb('makeModel', params, seoParams), (element) => {
      element.title = translateMake(element.title);
      seoElements.push(element);
    });
    params.makeModel = {};
  }
  if (get(active, 'fuel')) {
    seoElements.push(setBreadCrumb('fuel', params));
    params.fuel = '';
  }
  if (get(active, 'category')) {
    seoElements.push(setBreadCrumb('category', params));
    params.category = '';
  }
  seoElements.push(setBreadCrumb(t(messages.header.enginesForSale), params));

  // Reverse the breadcrumbs order, giving more priority to SRP, Class,
  // Make & Model and less priority to the location. Remove last link.
  let breadCrumbs = concat(seoElements, [{ title: t(messages.header.home), link: '/' }]);
  delete breadCrumbs[0].link;
  return reverse(breadCrumbs);
};

const setBreadCrumb = (key, params) => {
  const { formatMessage: t, messages } = syncTranslationElements();
  let param = get(params, key);
  let link = generateSearchPath({}, params, true);

  switch (key) {
  case 'category':
    return { title: capitalizeWords(t(messages.categoryFacetText[param])), link: link };
  case 'fuel':
    return { title: capitalizeWords(t(messages.fuelTypeFacetText[param])), link: link };
  default:
    return { title: key, link: link };
  }
};

const setMultifacetedBreadCrumb = (key, params, seoParams) => {
  let breadCrumbs = [];
  let items = get(params, key);
  let item = keys(items)[0];
  if (items[item][0]) {
    let subItem = items[item][0];
    /* Multifaceted BREADCRUMB WITH 'all' SELECTED IS NOT USED YET
      BUT IT WILL BE USED WHEN WE ADD REGIONS.
    */
    if (subItem !== handleLegacyAllType(item, 'all')) {
      params[key] = { [item]: [subItem] };
      let subItemTitle = seoParams.model;
      breadCrumbs.push({ title: subItemTitle, link: generateSearchPath({}, params, true) });
    }
  }
  params[key] = { [item]: [] };
  let itemTitle = seoParams.make;
  breadCrumbs.push({ title: itemTitle, link: generateSearchPath({}, params, true)});
  return breadCrumbs;
};
